import type { Quest } from '@/constant/schema';
import { buildPublicLearnHref, buildPublicPracticeHref } from '@/lib/seo/public-slugs';

export type TextbookTocChapter = {
  id: string;
  title: string;
  lessons: Array<{
    id: string;
    title: string;
    learnPath: string;
    practicePath: string;
  }>;
};

export type TextbookTocData = {
  title: string;
  chapters: TextbookTocChapter[];
  description?: string;
  subject?: string;
  grade?: string;
};

export function buildTextbookTocData(title: string, quest: Quest | null): TextbookTocData | null {
  if (!quest?.chapters?.length) {
    return null;
  }

  const chapters = quest.chapters
    .map((chapter) => ({
      id: chapter.id,
      title: chapter.title || 'Untitled chapter',
      lessons: (chapter.lesson_list || [])
        .filter((lesson) => Boolean(lesson.id) && Boolean(lesson.title))
        .map((lesson) => ({
          id: lesson.id,
          title: lesson.title,
          learnPath: buildPublicLearnHref(lesson.title, lesson.id),
          practicePath: buildPublicPracticeHref(lesson.title, lesson.id),
        })),
    }))
    .filter((chapter) => Boolean(chapter.id) && chapter.lessons.length > 0);

  if (!chapters.length) {
    return null;
  }

  return {
    title,
    chapters,
    subject: (quest as { subject?: string }).subject?.trim() || undefined,
    grade: (quest as { default_grade?: string }).default_grade?.trim() || undefined,
  };
}
